import { Tab } from '../models';

export enum TabIndex {
  FLIGHTS,
  PACKAGES,
  HOTELS,
  FLIGHT_HOTEL,
  INSURANCE,
  HOT_SALE,
}

export const TABS_DATA: Tab[] = [
  {
    icon: 'icon-plane-takeoff',
    name: 'Vuelos',
    path: 'vuelos',
    badge: '',
  },
  {
    icon: 'icon-suitcase',
    name: 'Paquetes',
    path: 'paquetes',
    badge: 'Ahorra',
  },
  {
    icon: 'icon-accommodation',
    name: 'Hoteles',
    path: 'hoteles',
    badge: '',
  },
  /*{
    icon: './assets/tabs/bag.svg',
    name: 'Paquetes',
    active: './assets/tabs/bag-red.svg',
    path: 'paquetes',
    navigates: true,
  },
  {
    icon: './assets/tabs/secure.svg',
    name: 'Seguros',
    active: './assets/tabs/secure-red.svg',
    path: 'seguro-viaje',
    navigates: true,
  },
  {
    icon: './assets/tabs/hot-sale.svg',
    name: 'OFERTAS',
    active: './assets/tabs/hot-sale.svg',
    path: 'ofertas',
    navigates: true,
  },*/
];
